/**
 * People & family emoji category with searchable keywords
 */
export const people = {
  name: 'People',
  icon: '👤',
  emojis: [
    { emoji: '👤', keywords: ['person', 'user', 'silhouette', 'profile', 'account'] },
    { emoji: '👥', keywords: ['people', 'users', 'group', 'team', 'crowd'] },
    { emoji: '🫂', keywords: ['hug', 'embrace', 'people', 'comfort', 'support'] },
    { emoji: '👪', keywords: ['family', 'parents', 'child', 'home', 'household'] },
    { emoji: '👨‍👩‍👦', keywords: ['family', 'parents', 'son', 'boy', 'dad', 'mom'] },
    { emoji: '👨‍👩‍👧', keywords: ['family', 'parents', 'daughter', 'girl', 'dad', 'mom'] },
    { emoji: '👨‍👩‍👧‍👦', keywords: ['family', 'parents', 'kids', 'children', 'siblings'] },
    { emoji: '👨‍👩‍👦‍👦', keywords: ['family', 'parents', 'sons', 'boys', 'brothers'] },
    { emoji: '👨‍👩‍👧‍👧', keywords: ['family', 'parents', 'daughters', 'girls', 'sisters'] },
    { emoji: '👨‍👦', keywords: ['family', 'father', 'son', 'dad', 'boy'] },
    { emoji: '👨‍👦‍👦', keywords: ['family', 'father', 'sons', 'dad', 'boys'] },
    { emoji: '👨‍👧', keywords: ['family', 'father', 'daughter', 'dad', 'girl'] },
    { emoji: '👨‍👧‍👦', keywords: ['family', 'father', 'kids', 'dad', 'children'] },
    { emoji: '👨‍👧‍👧', keywords: ['family', 'father', 'daughters', 'dad', 'girls'] },
    { emoji: '👩‍👦', keywords: ['family', 'mother', 'son', 'mom', 'boy'] },
    { emoji: '👩‍👦‍👦', keywords: ['family', 'mother', 'sons', 'mom', 'boys'] },
    { emoji: '👩‍👧', keywords: ['family', 'mother', 'daughter', 'mom', 'girl'] },
    { emoji: '👩‍👧‍👦', keywords: ['family', 'mother', 'kids', 'mom', 'children'] },
    { emoji: '👩‍👧‍👧', keywords: ['family', 'mother', 'daughters', 'mom', 'girls'] },
    { emoji: '🧑‍🤝‍🧑', keywords: ['couple', 'people', 'holding', 'hands', 'friends'] },
    { emoji: '👭', keywords: ['women', 'holding', 'hands', 'friends', 'couple'] },
    { emoji: '👫', keywords: ['couple', 'holding', 'hands', 'man', 'woman'] },
    { emoji: '👬', keywords: ['men', 'holding', 'hands', 'friends', 'couple'] },
    { emoji: '💏', keywords: ['kiss', 'couple', 'love', 'romance', 'dating'] },
    { emoji: '💑', keywords: ['couple', 'heart', 'love', 'romance', 'dating'] },
    { emoji: '👨‍💻', keywords: ['technologist', 'developer', 'programmer', 'coder', 'man'] },
    { emoji: '👩‍💻', keywords: ['technologist', 'developer', 'programmer', 'coder', 'woman'] },
    { emoji: '🧑‍💻', keywords: ['technologist', 'developer', 'programmer', 'coder', 'person'] },
    { emoji: '👨‍💼', keywords: ['office', 'worker', 'business', 'man', 'manager'] },
    { emoji: '👩‍💼', keywords: ['office', 'worker', 'business', 'woman', 'manager'] },
    { emoji: '🧑‍💼', keywords: ['office', 'worker', 'business', 'person', 'manager'] },
    { emoji: '👨‍🔧', keywords: ['mechanic', 'worker', 'fix', 'repair', 'man'] },
    { emoji: '👩‍🔧', keywords: ['mechanic', 'worker', 'fix', 'repair', 'woman'] },
    { emoji: '🧑‍🔧', keywords: ['mechanic', 'worker', 'fix', 'repair', 'person'] },
    { emoji: '👨‍🔬', keywords: ['scientist', 'research', 'lab', 'chemistry', 'man'] },
    { emoji: '👩‍🔬', keywords: ['scientist', 'research', 'lab', 'chemistry', 'woman'] },
    { emoji: '🧑‍🔬', keywords: ['scientist', 'research', 'lab', 'chemistry', 'person'] },
    { emoji: '👨‍🎨', keywords: ['artist', 'painter', 'creative', 'art', 'man'] },
    { emoji: '👩‍🎨', keywords: ['artist', 'painter', 'creative', 'art', 'woman'] },
    { emoji: '🧑‍🎨', keywords: ['artist', 'painter', 'creative', 'art', 'person'] },
    { emoji: '👨‍🚀', keywords: ['astronaut', 'space', 'nasa', 'rocket', 'man'] },
    { emoji: '👩‍🚀', keywords: ['astronaut', 'space', 'nasa', 'rocket', 'woman'] },
    { emoji: '🧑‍🚀', keywords: ['astronaut', 'space', 'nasa', 'rocket', 'person'] },
    { emoji: '🧙', keywords: ['mage', 'wizard', 'magic', 'fantasy', 'spell'] },
    { emoji: '🧙‍♂️', keywords: ['wizard', 'mage', 'magic', 'fantasy', 'man'] },
    { emoji: '🧙‍♀️', keywords: ['witch', 'mage', 'magic', 'fantasy', 'woman'] },
    { emoji: '🧚', keywords: ['fairy', 'magic', 'fantasy', 'wings', 'pixie'] },
    { emoji: '🧛', keywords: ['vampire', 'dracula', 'halloween', 'blood', 'fangs'] },
    { emoji: '🧜', keywords: ['merperson', 'mermaid', 'merman', 'sea', 'ocean'] },
    { emoji: '🧝', keywords: ['elf', 'fantasy', 'ears', 'magic', 'lotr'] },
    { emoji: '🧞', keywords: ['genie', 'lamp', 'wish', 'magic', 'aladdin'] },
    { emoji: '🧟', keywords: ['zombie', 'undead', 'walking', 'dead', 'halloween'] },
    { emoji: '💆', keywords: ['massage', 'spa', 'relax', 'face', 'treatment'] },
    { emoji: '💇', keywords: ['haircut', 'salon', 'barber', 'style', 'cut'] },
    { emoji: '🚶', keywords: ['walk', 'pedestrian', 'person', 'stroll', 'moving'] },
    { emoji: '🧍', keywords: ['standing', 'person', 'still', 'waiting', 'pose'] },
    { emoji: '🧎', keywords: ['kneel', 'person', 'pray', 'bow', 'down'] },
    { emoji: '🏃', keywords: ['run', 'runner', 'jog', 'exercise', 'sprint'] },
    { emoji: '👶', keywords: ['baby', 'infant', 'child', 'newborn', 'kid'] },
    { emoji: '👧', keywords: ['girl', 'child', 'kid', 'young', 'daughter'] },
    { emoji: '🧒', keywords: ['child', 'kid', 'young', 'person', 'youth'] },
    { emoji: '👦', keywords: ['boy', 'child', 'kid', 'young', 'son'] },
    { emoji: '👩', keywords: ['woman', 'female', 'lady', 'adult', 'person'] },
    { emoji: '🧑', keywords: ['person', 'adult', 'human', 'individual'] },
    { emoji: '👨', keywords: ['man', 'male', 'guy', 'adult', 'person'] },
  ],
};

export default people;

